// Subscription management dialog (отличается от UpgradeModal — этот для уже
// платящих, чтобы менять тариф / отменить / посмотреть инвойсы).
import { create } from "zustand";

export type SubscriptionModalTab = "overview" | "plans" | "invoices" | "payment-method";

interface SubscriptionModalState {
	isOpen: boolean;
	activeTab: SubscriptionModalTab;
	open: (tab?: SubscriptionModalTab) => void;
	close: () => void;
	setTab: (tab: SubscriptionModalTab) => void;
}

export const useSubscriptionModalStore = create<SubscriptionModalState>((set) => ({
	isOpen: false,
	activeTab: "overview",
	open: (tab = "overview") => set({ isOpen: true, activeTab: tab }),
	close: () => set({ isOpen: false }),
	setTab: (activeTab) => set({ activeTab }),
}));
